import { render, staticRenderFns } from "./UserFunction.vue?vue&type=template&id=2b9d5536&scoped=true"
import script from "./UserFunction.vue?vue&type=script&lang=js"
export * from "./UserFunction.vue?vue&type=script&lang=js"
import style0 from "./UserFunction.vue?vue&type=style&index=0&id=2b9d5536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d5536",
  null
  
)

export default component.exports